module.exports = __webpack_public_path__ + "static/img/logo.f3895ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/pic/logo.jpg
// module id = lD5/
// module chunks = 1